export const CAPACITY_MEMBER_PAGE_SIZE = 50;

/** How many task rows the flat People view reveals per scroll step. Tasks fill
 * the page before the next page of members loads (see CapacityPlanningStore). */
export const CAPACITY_TASK_PAGE_SIZE = 50;
